import { CommonModule } from '@angular/common';
import { FooterComponent } from './components/footer/footer.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { NgModule } from '@angular/core';
import { RootContainerComponent } from './components/root-container/root-container.component';
import { SharedModule } from '../shared/shared.module';
import { LoginComponent } from "./components/login/login.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RegisterComponent } from "./components/register/register.component";
import { VerifyComponent } from './components/verify/verify.component';
import { NgOtpInputModule } from "ng-otp-input";
import { FooterSocialMediaRowComponent } from './components/footer/footer-social-media-row/footer-social-media-row.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ProfileComponent } from './components/profile/profile.component';
import { StarRatingModule } from 'angular-star-rating';
import { MobileProfileComponent } from './components/mobile-profile/mobile-profile.component';

@NgModule({
	declarations: [
		RootContainerComponent,
		NavBarComponent,
		FooterComponent,
		LoginComponent,
		RegisterComponent,
		VerifyComponent,
		FooterSocialMediaRowComponent,
		ForgotPasswordComponent,
		ResetPasswordComponent,
		ProfileComponent,
		MobileProfileComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		FormsModule,
		ReactiveFormsModule,
		NgOtpInputModule,
		StarRatingModule
	],
	exports: [
		FormsModule,
	],
})
export class RootModule {
}
